/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { initDetailsAnimation } from './animate-details';

// Youtube/Vimeo popups
Fancybox.bind('.popup-youtube, .popup-vimeo', {
	on: {
		'Carousel.ready': (fancyboxRef) => {
			const fancybox = fancyboxRef.getOptions();
			const fancyboxContainer = fancyboxRef.getContainer()?.querySelector('.f-html');
			const containerSection = fancybox.triggerEl.closest('section');

			if (containerSection) {
				const transcription = containerSection.querySelector('[data-video-transcription]');
				if (transcription) {
					if (!fancyboxContainer.querySelector('[data-video-transcription]')) {
						const transcriptionClone = transcription.cloneNode(true);
						transcriptionClone.classList.remove('hidden');
						transcriptionClone.classList.add('absolute', 'w-full', 'top-full', 'left-0');
						fancyboxContainer.classList.add('relative');
						fancyboxContainer.append(transcriptionClone);
					}

					initDetailsAnimation(fancyboxContainer);
				}
			}

			fancyboxContainer.querySelector('.is-close-button').focus();
			fancyboxContainer.querySelector('iframe').setAttribute('title', 'Play Video');
		},
	},
});

// Default WP Gallery popups
Fancybox.bind('.popup-gallery', {
	Thumbs: { type: 'classic' },
	on: {
		'Carousel.ready': (fancyboxRef) => {
			const toolbar = fancyboxRef.getContainer()?.querySelector('.f-carousel__toolbar');
			toolbar.querySelector('[data-fancybox-close]')?.focus();
		},
	},
});
